/**
 * Property-page Task Automator list, filters, and create/edit dialog.
 */
function createTaskAutomatorSectionContent({ propertyId, propertyHrId, baseApiUrl }) {
  const container = document.createElement('div')
  const escapeValue = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;')
  const ICONS = LUX_ROW_ACTION_ICONS
  container.className = 'task-automator-container'
  container.innerHTML = `
    <style>
      .task-automator-container { color: rgba(0,0,0,.88); }
      .task-automator-header { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:24px; }
      .task-automator-title { margin:0; font-size:24px; line-height:32px; font-weight:600; }
      .task-automator-subtitle { margin:4px 0 0; color:rgba(0,0,0,.45); font-size:14px; }
      .task-automator-filters { display:flex; align-items:center; gap:8px; flex-wrap:wrap; padding:8px; margin-bottom:16px; border:1px solid #f0f0f0; border-radius:8px; background:#fff; }
      .task-automator-filters label { color:rgba(0,0,0,.45); font-size:12px; font-weight:500; padding:0 8px; }
      .task-automator-filters select, .task-automator-filters input { height:32px; padding:0 8px; border:1px solid #d9d9d9; border-radius:6px; background:#fff; font-size:13px; font-family:inherit; color:rgba(0,0,0,.88); line-height:normal; }
      .task-automator-filters input { margin-left:auto; max-width:260px; padding:0 12px 0 32px; }
      .task-automator-search-wrap { position:relative; margin-left:auto; }
      .task-automator-search-wrap::before { content:'⌕'; position:absolute; left:10px; top:50%; transform:translateY(-50%); color:rgba(0,0,0,.45); font-size:14px; }
      .task-automator-search { width:320px; max-width:100%; padding-left:28px; }
      .task-automator-table-wrap { border:1px solid #f0f0f0; border-radius:8px; overflow:auto; background:#fff; }
      .task-automator-table { width:100%; min-width:860px; border-collapse:collapse; }
      .task-automator-table th { padding:8px 16px; background:#fafafa; border-bottom:1px solid #f0f0f0; color:rgba(0,0,0,.45); font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:.04em; text-align:left; }
      .task-automator-table td { padding:12px 16px; border-bottom:1px solid #f0f0f0; vertical-align:middle; }
      .task-automator-table tr:hover td { background:#fafafa; }
      .task-automator-table tr:hover .task-automator-row-actions { opacity:1; }
      .task-automator-name { font-size:14px; font-weight:500; }
      .task-automator-sub { margin-top:2px; color:rgba(0,0,0,.45); font-size:13px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:220px; }
      .task-automator-avatar-stack { display:flex; align-items:center; }
      .task-automator-avatar { width:28px; height:28px; margin-left:-8px; border:2px solid #fff; border-radius:999px; background:#f0f0f0; color:rgba(0,0,0,.75); display:inline-flex; align-items:center; justify-content:center; font-size:10px; font-weight:600; cursor:default; }
      .task-automator-avatar:first-child { margin-left:0; }
      .task-automator-avatar-more { margin-left:-8px; border:2px solid #fff; background:#e6f4ff; color:#1677ff; cursor:pointer; padding:0; }
      .task-automator-status { display:inline-block; padding:2px 8px; border-radius:4px; font-size:12px; font-weight:500; }
      .task-automator-status-active { background:#f6ffed; color:#237804; border:1px solid #b7eb8f; }
      .task-automator-status-inactive { background:#fafafa; color:rgba(0,0,0,.45); border:1px solid #f0f0f0; }
      .task-automator-status-error { background:#fff1f0; color:#a8071a; border:1px solid #ffa39e; }
      .task-automator-row-actions { display:flex; justify-content:flex-end; gap:4px; opacity:0; }
      .task-automator-icon-btn { width:28px; height:28px; border:0; background:transparent; color:rgba(0,0,0,.45); border-radius:4px; cursor:pointer; display:inline-flex; align-items:center; justify-content:center; }
      .task-automator-icon-btn:hover { background:#f5f5f5; color:rgba(0,0,0,.88); }
      .task-automator-footer { display:flex; justify-content:space-between; align-items:center; padding:8px 16px; border-top:1px solid #f0f0f0; color:rgba(0,0,0,.45); font-size:13px; }
      .task-automator-empty { padding:24px; text-align:center; color:rgba(0,0,0,.45); }
      .task-automator-icon-btn:disabled { opacity:.5; cursor:default; }
      .task-automator-row-busy { opacity:.55; pointer-events:none; }
      .task-automator-spinner { display:inline-block; width:14px; height:14px; border:2px solid rgba(0,0,0,.15); border-top-color:rgba(0,0,0,.6); border-radius:50%; animation:task-automator-spin .7s linear infinite; vertical-align:middle; }
      @keyframes task-automator-spin { to { transform: rotate(360deg); } }
    </style>
    <div class="task-automator-header">
      <div>
      </div>
      <button type="button" class="ant-btn ant-btn-primary Button task-automator-create">
        <span>Neuen Zeitplan erstellen</span>
      </button>
    </div>
    <div class="task-automator-filters">
      <label>Filter:</label>
      <select class="task-automator-status-filter">
        <option value="all">Status: Alle</option>
        <option value="active">Aktiv</option>
        <option value="inactive">Inaktiv</option>
        <option value="error">Mit Fehler</option>
      </select>
      <select class="task-automator-frequency-filter">
        <option value="all">Häufigkeit: Alle</option>
        <option value="every_x_weeks">Wöchentlich</option>
        <option value="monthly">Monatlich</option>
        <option value="yearly">Jährlich</option>
      </select>
      <div class="task-automator-search-wrap">
        <input class="ant-input task-automator-search" placeholder="Nach Aufgabenname oder Empfänger suchen…" />
      </div>
    </div>
    <div class="task-automator-message" style="display:none;padding:12px;margin-bottom:12px;border-radius:6px;"></div>
    <div class="task-automator-list task-automator-table-wrap">
      <div class="task-automator-empty">Zeitpläne werden geladen…</div>
    </div>
  `

  const list = container.querySelector('.task-automator-list')
  const message = container.querySelector('.task-automator-message')
  const searchInput = container.querySelector('.task-automator-search')
  const statusFilter = container.querySelector('.task-automator-status-filter')
  const frequencyFilter = container.querySelector('.task-automator-frequency-filter')
  let cachedSchedules = []
  let cachedRecipientOptions = []
  let cachedOperationalContacts = []

  const prefetchEditor = () => {
    if (document.getElementById('task-automator-prefetch')) return
    const link = document.createElement('link')
    link.id = 'task-automator-prefetch'
    link.rel = 'prefetch'
    link.href = `${baseApiUrl}/properties/${encodeURIComponent(propertyHrId)}/task-automator?propertyId=${encodeURIComponent(propertyId)}`
    document.head.appendChild(link)
  }
  prefetchEditor()

  const showMessage = (text, error = false) => {
    message.textContent = text
    message.style.display = 'block'
    message.style.background = error ? '#fff1f0' : '#f6ffed'
    message.style.color = error ? '#a8071a' : '#237804'
    message.style.border = `1px solid ${error ? '#ffa39e' : '#b7eb8f'}`
  }

  const formatDate = (value, withTime = false) => {
    if (!value) return '–'
    const date = withTime ? new Date(value) : new Date(`${String(value).slice(0, 10)}T12:00:00`)
    if (Number.isNaN(date.getTime())) return '–'
    return new Intl.DateTimeFormat('de-DE', withTime
      ? { dateStyle: 'medium', timeStyle: 'short' }
      : { dateStyle: 'medium' }).format(date)
  }

  const cadenceLabel = (schedule) => {
    if (schedule.recurrenceKind === 'every_x_weeks') {
      return schedule.intervalWeeks === 1 ? 'Wöchentlich' : `Alle ${schedule.intervalWeeks} Wochen`
    }
    if (schedule.recurrenceKind === 'yearly') return 'Jährlich'
    return 'Monatlich'
  }

  const initials = (name) => {
    const parts = String(name || '').split(/\s+/).filter(Boolean)
    if (!parts.length) return '?'
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }

  const avatarMarkup = (name) =>
    `<span class="task-automator-avatar" title="${escapeValue(name)}">${escapeValue(initials(name))}</span>`

  const renderAssigneeAvatars = (stack, recipients, expanded = false) => {
    if (!recipients.length) {
      stack.innerHTML = '<span style="color:rgba(0,0,0,.45);">–</span>'
      return
    }
    const visible = expanded ? recipients : recipients.slice(0, 2)
    const rest = expanded ? 0 : Math.max(0, recipients.length - 2)
    stack.innerHTML = `
      ${visible.map(avatarMarkup).join('')}
      ${rest ? `<button type="button" class="task-automator-avatar task-automator-avatar-more" title="Alle Empfänger anzeigen">+${rest}</button>` : ''}
    `
    const more = stack.querySelector('.task-automator-avatar-more')
    if (more) {
      more.addEventListener('click', (event) => {
        event.stopPropagation()
        renderAssigneeAvatars(stack, recipients, true)
      })
    }
  }

  const statusLabel = (schedule) => {
    if (schedule.lastError) return { text: 'Fehler', className: 'task-automator-status-error' }
    if (schedule.isActive) return { text: 'Aktiv', className: 'task-automator-status-active' }
    return { text: 'Inaktiv', className: 'task-automator-status-inactive' }
  }

  const openEditor = (scheduleId) => {
    const params = new URLSearchParams({
      propertyId: String(propertyId),
    })
    if (scheduleId) params.set('scheduleId', String(scheduleId))
    window.location.assign(
      `${baseApiUrl}/properties/${encodeURIComponent(propertyHrId)}/task-automator?${params.toString()}`
    )
  }

  const request = async (url, options = {}) => {
    const response = await fetch(`${baseApiUrl}${url}`, {
      credentials: 'include',
      ...options,
      headers: {
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
    })
    const data = await response.json()
    if (!response.ok) throw new Error(data.error || 'Anfrage fehlgeschlagen.')
    return data
  }

  const renderSchedules = (
    schedules = cachedSchedules,
    recipientOptions = cachedRecipientOptions,
    operationalContacts = cachedOperationalContacts
  ) => {
    cachedSchedules = schedules
    cachedRecipientOptions = recipientOptions
    cachedOperationalContacts = operationalContacts
    list.innerHTML = ''
    const recipientNames = new Map(
      recipientOptions.map((option) => [Number(option.id), option.name || option.email || `Kontakt #${option.id}`])
    )
    const query = searchInput.value.trim().toLowerCase()
    const selectedStatus = statusFilter.value
    const selectedFrequency = frequencyFilter.value
    const filteredSchedules = schedules.filter((schedule) => {
      const recipientText = (schedule.resolvedRecipientContactIds || schedule.directRecipientContactIds || [])
        .map((id) => recipientNames.get(Number(id)) || `Kontakt #${id}`)
        .join(' ')
      const searchable = `${schedule.title} ${recipientText} ${(schedule.recipientOperationalRoles || []).join(' ')}`.toLowerCase()
      const matchesStatus =
        selectedStatus === 'all' ||
        (selectedStatus === 'active' && schedule.isActive) ||
        (selectedStatus === 'inactive' && !schedule.isActive) ||
        (selectedStatus === 'error' && schedule.lastError)
      const matchesFrequency =
        selectedFrequency === 'all' || schedule.recurrenceKind === selectedFrequency
      return (!query || searchable.includes(query)) && matchesStatus && matchesFrequency
    })
    if (!filteredSchedules.length) {
      list.innerHTML = '<div class="task-automator-empty">Keine Zeitpläne gefunden.</div>'
      return
    }
    const table = document.createElement('table')
    table.className = 'task-automator-table'
    table.innerHTML = `
      <thead>
        <tr>
          <th>Aufgabenname</th>
          <th>Wiederholung</th>
          <th>Empfänger</th>
          <th>Nächster Termin</th>
          <th style="text-align:center;width:100px;">Status</th>
          <th style="text-align:right;width:80px;">Aktionen</th>
        </tr>
      </thead>
      <tbody></tbody>
    `
    const tbody = table.querySelector('tbody')
    filteredSchedules.forEach((schedule) => {
      const recipients = (schedule.resolvedRecipientContactIds || schedule.directRecipientContactIds || [])
        .map((id) => recipientNames.get(Number(id)) || `Kontakt #${id}`)
      const status = statusLabel(schedule)
      const row = document.createElement('tr')
      if (!schedule.isActive) row.style.opacity = '0.7'
      row.innerHTML = `
        <td>
          <div class="task-automator-name">${escapeValue(schedule.title)}</div>
          <div class="task-automator-sub">${escapeValue(schedule.associatedItemLabel || 'Keine Verknüpfung')}</div>
          ${schedule.lastError ? `<div style="margin-top:6px;color:#cf1322;font-size:12px;">${escapeValue(schedule.lastError)}</div>` : ''}
        </td>
        <td>
          <div style="display:flex;align-items:center;gap:6px;font-size:13px;">
            <span aria-hidden="true">↻</span>
            ${escapeValue(cadenceLabel(schedule))}
          </div>
        </td>
        <td>
          <div class="task-automator-avatar-stack"></div>
        </td>
        <td style="font-size:13px;">${schedule.isActive ? formatDate(schedule.nextOccurrenceDate) : '–'}</td>
        <td style="text-align:center;">
          <span class="task-automator-status ${status.className}">${status.text}</span>
        </td>
        <td>
          <div class="task-automator-row-actions">
            <button type="button" class="task-automator-icon-btn task-automator-toggle" title="${schedule.isActive ? 'Deaktivieren' : 'Aktivieren'}">${schedule.isActive ? ICONS.pause : ICONS.play}</button>
            <button type="button" class="task-automator-icon-btn task-automator-edit" title="Bearbeiten">${ICONS.edit}</button>
            <button type="button" class="task-automator-icon-btn task-automator-delete" title="Löschen">${ICONS.delete}</button>
          </div>
        </td>
      `
      renderAssigneeAvatars(row.querySelector('.task-automator-avatar-stack'), recipients)
      const toggleBtn = row.querySelector('.task-automator-toggle')
      const deleteBtn = row.querySelector('.task-automator-delete')
      row.querySelector('.task-automator-edit').addEventListener('click', () => openEditor(schedule.id))
      toggleBtn.addEventListener('click', async () => {
        setRowBusy(row, toggleBtn)
        try {
          await request(`/api/task-automator/schedules/${schedule.id}`, {
            method: 'PATCH',
            body: JSON.stringify({ isActive: !schedule.isActive }),
          })
          loadSchedules()
        } catch (error) {
          showMessage(error.message, true)
          renderSchedules()
        }
      })
      deleteBtn.addEventListener('click', async () => {
        const confirmed = await confirmPopover(deleteBtn, { name: schedule.title })
        if (!confirmed) return
        setRowBusy(row, deleteBtn)
        try {
          await request(`/api/task-automator/schedules/${schedule.id}`, { method: 'DELETE' })
          loadSchedules()
        } catch (error) {
          showMessage(error.message, true)
          renderSchedules()
        }
      })
      tbody.appendChild(row)
    })
    list.appendChild(table)
    list.insertAdjacentHTML(
      'beforeend',
      `<div class="task-automator-footer">
        <span>1 bis ${filteredSchedules.length} von ${schedules.length} Einträgen</span>
        <div style="display:flex;gap:4px;">
          <button type="button" class="ant-btn ant-btn-default ant-btn-sm" disabled>&lt;</button>
          <button type="button" class="ant-btn ant-btn-default ant-btn-sm" disabled>&gt;</button>
        </div>
      </div>`
    )
  }

  const setRowBusy = (row, activeButton) => {
    row.classList.add('task-automator-row-busy')
    row.querySelectorAll('.task-automator-icon-btn').forEach((button) => {
      button.disabled = true
    })
    if (activeButton) activeButton.innerHTML = '<span class="task-automator-spinner"></span>'
  }

  searchInput.addEventListener('input', () => renderSchedules())
  statusFilter.addEventListener('change', () => renderSchedules())
  frequencyFilter.addEventListener('change', () => renderSchedules())

  const loadSchedules = async () => {
    try {
      const params = new URLSearchParams({
        propertyId: String(propertyId),
        propertyHrId,
      })
      const data = await request(`/api/task-automator/schedules?${params.toString()}`)
      renderSchedules(
        data.schedules || [],
        data.recipientOptions || [],
        data.operationalContacts || []
      )
    } catch (error) {
      list.innerHTML = ''
      showMessage(error.message || 'Automatoren konnten nicht geladen werden.', true)
    }
  }

  container.querySelector('.task-automator-create').addEventListener('click', () => openEditor())
  loadSchedules()
  return container
}
